import React from "react";
import Container from "Components/Container/Container";
import SectionHeader from "Components/SectionHeader/SectionHeader";
import { motion } from "framer-motion";
import FadeInAnimation from "Components/FadeInAnimation/FadeInAnimation";
import Reavel from "Components/Reveal/Reavel";
import tapisVertImage from "assets/images/tapis_vert.jpeg";
import maBrasserieImage from "assets/images/ma_brasserie.jpg";
import bromontImage from "assets/images/bromont.jpg";
import fitzroyImage from "assets/images/fitzroy.jpg";
import tornadoMontrealImage from "assets/images/tornado_mtl.jpg";
import { Link } from "react-router-dom";

const Hebdos = () => {
  const fadeInAnimation = {
    initial: {
      opacity: 0,
      y: 100,
    },
    animate: (custom) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: custom + 0.07,
        duration: 0.5,
      },
    }),
  };

  return (
    <div className="bg-gray-700 bg-amber-300 pb-10 lg:pb-20 pt-4" id="hebdos">
      <SectionHeader heading={"Les tournois hebdomadaires"}></SectionHeader>
      <FadeInAnimation>
        <div className="flex flex-col lg:flex-row-reverse justify-center items-center mb-8">
          <div className="flex flex-row items-center space-x-4 lg:space-x-8">
            <Reavel>
              <p className="text-white text-slate-700 md:text-2xl px-4">
                De nombreux tournois se déroulent chaque semaine au Québec, et
                il est facile de s'y inscrire.
              </p>
            </Reavel>
          </div>
        </div>
      </FadeInAnimation>
      <Container>
        <div className="-m-1 lg:flex lg:flex-wrap  md:-m-2">
          <motion.div
            className="flex lg:w-1/2 flex-wrap"
            variants={fadeInAnimation}
            initial="initial"
            custom={0}
            whileInView="animate"
            viewport={{ once: true }}
          >
            <div className="lg:w-1/2 p-1 md:p-2 relative group">
              <a
                href="https://www.facebook.com/profile.php?id=100073949215243"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="relative overflow-hidden rounded-lg">
                  <img
                    alt="gallery"
                    loading="lazy"
                    className="hebdos_card_img h-96"
                    src={fitzroyImage}
                  />
                  <div className="hebdos_card_overlay"></div>
                  <div className="absolute inset-0 text-white p-3 top-2/4 md:top-3/4 lg:top-2/4">
                    <h4 className="text-xl font-semibold">Fitzroy</h4>
                    <p>
                      Tous les Lundis soir à Montréal sur Bonzini et Leonhart
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="lg:w-1/2 p-1 md:p-2 relative group">
              <a
                href="https://www.facebook.com/groups/861240792013102"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="relative overflow-hidden rounded-lg">
                  <img
                    alt="gallery"
                    loading="lazy"
                    className="hebdos_card_img h-96"
                    src={bromontImage}
                  />
                  <div className="hebdos_card_overlay"></div>
                  <div className="absolute inset-0 text-white p-3 top-2/4 lg:top-2/4 md:top-3/4">
                    <h4 className="text-xl font-semibold">Bromont</h4>
                    <p>Soirées variées à Bromont sur Leonhart</p>
                  </div>
                </div>
              </a>
            </div>
            <a
              href="https://www.facebook.com/groups/328775394216938"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="w-full p-1 md:p-2 relative group">
                <div className="relative overflow-hidden rounded-lg">
                  <img
                    alt="gallery"
                    loading="lazy"
                    className="hebdos_card_img"
                    src={maBrasserieImage}
                  />
                  <div className="hebdos_card_overlay"></div>
                  <div className="absolute inset-0 text-white p-3 top-2/4 md:top-3/4">
                    <h4 className="text-xl font-semibold">Ma Brasserie</h4>
                    <p>Tous les Mercredis soir à Montréal sur Bonzini</p>
                  </div>
                </div>
              </div>
            </a>
          </motion.div>
          <motion.div
            className="lg:flex lg:w-1/2 lg:flex-wrap"
            variants={fadeInAnimation}
            initial="initial"
            custom={0.15}
            whileInView="animate"
            viewport={{ once: true }}
          >
            <a
              href="https://www.facebook.com/groups/163712353649413"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="w-full p-1 md:p-2 relative group">
                <div className="relative overflow-hidden rounded-lg">
                  <img
                    alt="gallery"
                    loading="lazy"
                    className="hebdos_card_img"
                    src={tapisVertImage}
                  />
                  <div className="hebdos_card_overlay"></div>
                  <div className="absolute inset-0 text-white p-3 top-2/4 md:top-3/4">
                    <h4 className="text-xl font-semibold">Tapis vert</h4>
                    <p>Tous les Mercredis soir à Québec sur Bonzini</p>
                  </div>
                </div>
              </div>
            </a>
            <div className="lg:w-1/2 p-1 md:p-2 relative group">
              <a
                href="https://www.facebook.com/profile.php?id=61557445048083"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="relative overflow-hidden rounded-lg">
                  <img
                    alt="gallery"
                    loading="lazy"
                    className="hebdos_card_img h-96"
                    src={tornadoMontrealImage}
                  />
                  <div className="hebdos_card_overlay"></div>
                  <div className="absolute inset-0 text-white p-3 top-2/4 lg:top-2/4 md:top-3/4">
                    <h4 className="text-xl font-semibold">
                      Brasserie Champlain
                    </h4>
                    <p>Tous les Samedis à Montréal sur Tornado</p>
                  </div>
                </div>
              </a>
            </div>
          </motion.div>
        </div>
      </Container>
    </div>
  );
};

export default Hebdos;
